export const getMetaForDysregulationQuizScore = (score, dataTimeOfDay, timeOfDay, firstName) => {
  if (score < 50) {
    return {name: "Depleted", color: "#FFC8E3", description: `Your nervous system appears to be noticeably dysregulated based on your results, ${firstName}. See the detailed breakdown below.`}
  } else if (score < 67) {
    return {name: "Recovering", color: "#FAE4C7", description: `Your nervous system appears to be moderately dysregulated based on your results, ${firstName}. See the detailed breakdown below.`}
  } else if (score < 80) {
    return {name: "Balanced", color: "#CFF2D2", description: `Based on your results, your nervous system appears to be moderately balanced, ${firstName}.`}
  } else if (score <= 100) {
    return {name: "Restored", color: "#F4FFAA", description: `Your nervous system seems to be highly balanced based on your results, ${firstName}.`}
  }
}

export const getMetaForQuizSymptomResultsData = (data, dataTimeOfDay, firstName) => {
  const score = data.filter(d => d.name === "overall")[0].value
  const dysregulationSymptoms = data.filter(d => ((d.name !== "overall") && (d.value <= 0.5))).map(s => s.name)
  const dysregulationSymptomCount = dysregulationSymptoms.length

  const explanationText = (dysregulationSymptomCount > 0) ? ` Nervous system dyregulation often leads to ${joinWithAnd(dysregulationSymptoms)} imbalances.` : ""
  if (score < 0.5) {
    return `Your results ${(dysregulationSymptomCount > 1) ? `contain several markers of` : `point to noticeable`} dysregulation, ${firstName}.${explanationText}`
  } else if (score < 0.67) {
    return `Your symptom results ${(dysregulationSymptomCount > 1) ? `contain several markers of` : `point to moderate`} nervous system dysregulation, ${firstName}.${explanationText}`
  } else if (score < 0.80) {
    return `Your symptom results point to moderate nervous system balance, ${firstName}.${explanationText}`
  } else if (score <= 1.0) {
    return  `Your symptom results suggest that your nervous system is highly balanced, ${firstName}.${explanationText}`
  }
}

export const getMetaForQuizHabitResultsData = (data, dataTimeOfDay, firstName) => {
  const score = data.filter(d => d.name === "overall")[0].value

  const dysregulationHabits = data.filter(d => ((d.name !== "overall") && (d.value <= 0.5))).map(s => s.name.toUpperCase())
  const dysregulationHabitsCount = dysregulationHabits.length

  const explanationText = (dysregulationHabitsCount > 0) ? ` Nervous system dyregulation often stems from inconsistency with ${joinWithAnd(dysregulationHabits)} habits.` : ""

  if (score < 0.5) {
    return `Your habit results often lead to noticeable dysregulation, ${firstName}.${explanationText}`
  } else if (score < 0.67) {
    return `Your habit results often lead to moderate dysregulation, ${firstName}.${explanationText}`
  } else if (score < 0.8) {
    return `Your habit results support moderate nervous system balance, ${firstName}.${explanationText}`
  } else if (score <= 1.0) {
    return  `Your habit results support a highly balanced nervous system, ${firstName} - keep it up.${explanationText}`
  }
}

export const getMetaForQuizSelfCheckInResultsData = (data, firstName) => {
  const positivePercentages = (data.parasympathetic || 0.0) + (data.stillness || 0.0) + (data.play || 0.0)
  const stillPercentages = (data.stillness || 0.0) + (data.dorsal_vagal || 0.0)
  const energizedPercentages = (data.play || 0.0) + (data.sympathetic || 0.0)
  let result = ""
  const descriptor = "Based on your check-in results, your nervous system"
  if (positivePercentages >= 0.875) {
    return `${descriptor} looks highly balanced, ${firstName} - great work.`
  } else if (positivePercentages >= 0.75) {
    result += `${descriptor} looks balanced, ${firstName} - nice work.`
  } else if (positivePercentages >= 0.625) {
    result += `${descriptor} looks fairly balanced, ${firstName}.`
    if (stillPercentages >= 0.25) {
      result += " For greater balance, ensure exercise and movement are a part of your daily routine."
    } else if (energizedPercentages >= 0.25) {
      result += " For greater balance, ensure stillness and reflection are a part of your daily routine."
    }
  } else if (positivePercentages >= 0.5) {
    result += `${descriptor} could use some balancing, ${firstName}.`
    if (stillPercentages >= 0.25 && energizedPercentages >= 0.25) {
      result += " Make sure to add more exercise and stillness to your routine."
    } else if (energizedPercentages >= 0.25) {
      result += " Make sure to add more stillness and reflection to your routine."
    } else if (stillPercentages >= 0.25) {
      result += " Make sure to add more exercise and movement to your routine."
    }
  } else {
    result += `${descriptor} is in need of balancing, ${firstName}.`
    if (stillPercentages >= 0.25 && energizedPercentages >= 0.25) {
      result += ` Take time to add more stillness and activity to your routine.`
    } else if (energizedPercentages >= 0.25) {
      result += ` Take time to add more stillness and reflection to your routine.`
    } else if (stillPercentages >= 0.25) {
      result += ` Take time to add more activity and movement to your routine.`
    }
  }

  return result
}

export const joinWithAnd = values => {
  if (values.length === 1) {
    return values[0]
  } else if (values.length === 2) {
    return `${values[0]} and ${values[1]}`
  } else {
    return `${values.slice(0, values.length - 1).join(", ")}, and ${values[values.length - 1]}`
  }
}
